import { callFilterRequest } from '../api/filter.js';
import { getStickyStatus } from '../filter-tree/sticky';
import { detectDeviceByWidth, isMobile, scrollToTop } from '../utils';

/**
 * @type {import('./index.d').handleViewAsClick}
 */
export const handleViewAsClick = async (context, target) => {
  if (target.classList.contains('boost-sd__view-as-icon')) {
    context.defaultParams.viewAs = target.getAttribute('data-value');
  } else {
    context.defaultParams.viewAs = target
      .closest('.boost-sd__view-as-icon')
      .getAttribute('data-value');
  }

  const isMobileSize = isMobile(context.app.generalSettings.breakpointmobile || 575);
  context.defaultParams.device = isMobileSize ? detectDeviceByWidth() : '';

  const [, setActiveViewAsButton] = context.useContextState('activeViewAsButton', null);

  setActiveViewAsButton(context.defaultParams.viewAs);
  const stickyStatus = getStickyStatus(context);
  if (stickyStatus.stickyEnabled) {
    scrollToTop({ behavior: 'auto' });
  }

  return callFilterRequest(context);
};
